import styled from 'styled-components';

const PairContainer = styled.div`
    padding: 1.5rem 1rem;
    font-family: NHaasGroteskTXPro, system-ui;
    .f-1 {
        flex: 1;
    }
    .first-title,
    .title {
        color: #ffffff;
        font-family: HaasGrotDisp;
        font-size: 24px;
        font-weight: bold;
    }
    .first-title {
        font-size: 28px;
        margin: 0.5rem 0rem;
    }
    .sub-title {
        color: #FFFFFF;
        font-family: HaasGrotDisp;
        font-size: 15px;
        font-weight: bold;
        margin-top: 5px;
    }
    .sub-txt {
            color: #A8A8B1;
        }
    .d-flex {
        display: flex;
    }
    .align-items-center {
        align-items: center;
    }
    .justify-content-between {
        justify-content: space-between;
    }
    .flex-container {
        flex: 1;
        margin: 0.25rem 0rem;
        .ant-select-dropdown-menu {
            background-color: red;
        }
        .coin-icon {
            margin-right: 5px;
            width: 1.5rem;
        }
    }
    .vs-content {
        color: #A8A8B1;
        padding: 0rem 1rem;
        width: 3rem;
    }
    .full-width {
        color: #fff;
        .ant-input-number {
            margin: 0.5rem 0rem;
            width: 100%;
        }
        .ant-select {
            margin-bottom: 0.75rem;
            width: 100%;
        }
        .ant-btn {
            margin-left: 5px;
        }
    }
    .pair-field-error {
        color: #f5222d;
        margin-bottom: 5px;
    }
    .coin-container {
        color: #A8A8B1 ;
        padding: 1.5rem 0rem;
        .pair-wrapper {
            display: flex;
            align-items: center;
        }
        .provider-display {
            text-align: right;
        }
        .footer-info {
            white-space: normal;
        }
        .coin-ico {
            background: transparent;
            color: #ffffff;
        }
    }
    .coin-select {
        border-bottom: 1px solid #A8A8B1;
    }
    .ant-checkbox-wrapper {
        display: flex;
        .ant-checkbox {
            margin-top: 10px;
        }
        .ant-checkbox-checked::after {
            border: none;
        }
    }
    .description {
        font-size: 12px;
    }
    .field-wrap {
        border-bottom: 1px solid #A8A8B1;
        padding: 1rem 0rem;
        width: 75%;
    }
    .last {
        border-bottom: none;
    }
    .edit-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem 0rem;
        border-top: 1px solid #A8A8B1;
    }
    .grey-warning {
        background-color: #545454;
        color: #ffffff;
        display: flex;
        padding: 1rem 2rem 1rem 1rem;
        margin-top: 2rem;

        .warning-text {
            font-size: 45px;
            padding: 0rem 2rem 0rem 1rem;
        }
        .icon-wrapper {
            margin-right: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .fiat-icon {
            width: 4rem;
        }
        .sub-title {
            color: #ffffff;
        }
    }
    .preview-container {
        margin: 1rem 0rem 2rem 0rem;
        .left-container-preview {
            margin-bottom: 2rem;
        }
        .left-container {
            justify-content: center;
        }
        .right-container {
            border-left: 1px solid #A8A8B1;
            padding: 0rem 1rem;
            width: 15rem;
            margin-left: 1rem;
        }
        .sub-title {
            font-weight: 100
        }
        .sub-txt {
            font-weight: 100
        }
    }
    .right-content {
        margin: 0rem 0rem 1rem 1rem;
        padding: 2rem 2rem;
        background: #212121;
    }
    .cross-text {
        color: #A8A8B1;
        font-size: 42px;
        padding-top: 1rem;
        margin: 0rem 0.5rem;
    }
    a {
        color: #5985ff;
    }
    .description-small {
        font-size: 10px;
        margin-top: 0.25rem;
        text-align: center;
        width: 70%;
    }
    .remove {
        color: #ff4d4f;
        text-align: left;
        width: 60%;
    }
    .configure-btn {
        font-size: 32px;
        height: auto;
    }
    .btn-wrapper {
        display: flex;
        margin-top: 1rem;
        .ant-btn {
            flex: 1
        }
        .separator {
            margin: 5px;
        }
        .ant-btn-primary {
            color: #fff;
            background-color: #3A4FFF;
            border-color: #3A4FFF;
        }
        .ant-btn-primary:disabled {
            color: #fff;
            background-color: #42454D;
            border-color: #42454D;
        }
    }
    .status-wrapper {
        position: relative;
    }
    .exclamation-icon {
        font-size: 22px;
        color: #FF0000;
        position: absolute;
        left: 65px;
        bottom: 75px;
    }
    .coin-config-align {
        position: absolute;
        left: 65px;
        bottom: 75px;
        z-index: 1
    }
    .coin-full-name {
        margin-left: 5px;
    }
    .ant-radio-group {
        width: 100%;
        .ant-select-selection {
            max-width: 11rem;
        }
    }
    .add-pair-radio-wrapper {
        padding: 5px 0px;
        width: 100%;
        .coin-container {
            padding: 0.5rem 0rem;
            margin: 2rem 0rem;
        }
        .steps-dash-link {
            color: #fff;
        }   
        .anchor {
            margin: 0% 1%;
        }
    }
    .asset-pairs {
        border: 1px solid #707070;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.5rem 0.75rem;
    }
    .coin-option-wrapper {
        border: 1px solid #707070;
        border-radius: 4px;
        margin-top: 0.5rem;
        max-height: 18rem;
        overflow-y: auto;
        .coin-option {
            padding: 1rem;
            color: #A8A8B1;
        }
        &:hover {
            border-color: #3A4FFF;
        }
        .coin-option:hover {
            background-color: #3A4FFF;
            color: #ffffff;
        }
        .coin-ico {
            background: transparent;
            color: #ffffff;
        }
    }
    .anchor {
        color: #3A4FFF;
        text-decoration: underline;
        cursor: pointer;
    }
    .footer {
        color: #A8A8B1;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-top: 35px;
    }
    .add-pair-wrapper {
        .link-color {
            color: #3A4FFF;
        }
        .sub-txt {
            color: #A8A8B1;
        }
        .tab-wrapper {
            padding: 0;
            width: 100%;
            border-top: 1px solid #A8A8B1;
            margin-top: 5px;
        }
        .ant-tabs-tab {
            flex: 1;
            text-align: center;
            border-top: 6px solid transparent;

            .tab-description {
                font-size: 11px;
                color: #7F7F7F;
                font-weight: normal;
            }
        }
        .ant-tabs-tab-active {
            border-top: 6px solid #ffffff;
        }
    }
    .ant-input-number {
            background-color: transparent;
            color: #ffffff;
            .ant-input-number-handler-wrap {
                background-color : transparent;
                color: #ffffff;
                .anticon {
                    color: white;
                }
            }
        }
    .coin-ico {
        background: transparent;
        color: #fff;
    }
    .ant-select-dropdown-menu-item {
        background-color: #212121 !important;
        color: #A8A8B1 !important;
    }
    .ant-breadcrumb {
		a {
		   color: #fff ;
			  text-decoration: none;
		  }
		  a:hover {
			  color: #ffffff;
		  }
		  }
		.ant-breadcrumb-link {
			color: #A8A8B1;
		.breadcrumb-item {
			color: #A8A8B1;
			cursor: pointer;
		}
		.breadcrumb-item-active {
			border-top: 5px solid #A8A8B1;
			color: #A8A8B1;
			cursor: pointer;
		}
	}

    .remove-confirmation-wrapper {
        color: #ffffff;
        .title {
            font-size: 18px;
            font-weight: normal;
        }
		.sub-text {
            color: #A8A8B1 !important;
			margin-top: 0.5rem;
		}
		.coin {
			display: flex;
			margin-top: 1rem;
		}
		.flex-container {
            display: flex;
			justify-content: space-between;
			width: 8rem;
		}
		.x-mark {
			position: relative;
			&::before {
                content: 'X';
				font-size: 22px;
				display: block;
				width: 50px;
				text-align: center;
				color: #ffffff;
				position: absolute;
				/* right: 14px; */
				left: 95%;
				top: 50%;
				transform: translateY(-50%);
			}
		}
		.coin-item {
			display: flex;
    		align-items: center;
			margin-left: 1rem;
		}
		.btn-wrapper {
            display: flex;
			justify-content: space-between;
			margin-top: 2rem;
			.ant-btn {
                width: 45%;
				height: 2.5rem;
			}
    	}
	}

    @media (max-width: 960px) {
        .flex-column-rev {
            flex-direction: column-reverse;
        }
        .configure-btn {
            font-size: 20px;
        }
        .coin-container {
            .pair-wrapper {
                display: unset;
            }
        }
        .add-pair-radio-wrapper {
            .coin-container {
                padding-left: 0;
                width: 100%;
            }
        }
        .preview-container {
            flex-direction: column;
            .left-container {
                justify-content: flex-start;
            }
            .right-container {
                border-left: none;
            }
        }
        .ant-radio-group {
            .ant-select-selection {
                max-width: 100%;
            }
        }
        .ant-radio-wrapper {
            white-space: normal;
            .coin-full-name {
                font-size: 12px;
            }
        }
        .field-wrap {
            width: 100%;
        }
    }
    @media (max-width:300px) {
        padding: 1.5rem 0.5rem;
        .preview-container {
            .right-container {
                margin-left: 0rem;
            }
        }
    }
`;

export default PairContainer;